import { render } from "./WelcomePopup.vue?vue&type=template&id=550b53ec&scoped=true"
import script from "./WelcomePopup.vue?vue&type=script&lang=js"
export * from "./WelcomePopup.vue?vue&type=script&lang=js"

import "./WelcomePopup.vue?vue&type=style&index=0&id=550b53ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550b53ec"]])

export default __exports__